import { useEffect } from 'react';

export default function GoogleTag() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-944951725';
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    // Google Tag requires the IArguments object (not a spread array)
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments as unknown as unknown[]);
    } as Window['gtag'];
    window.gtag('js', new Date());
    window.gtag('config', 'AW-944951725');

    window.gtag_report_conversion = function (url?: string) {
      const callback = () => {
        if (url) window.location.href = url;
      };
      window.gtag('event', 'conversion', {
        send_to: 'AW-944951725/UAlQCIGfys0DEK2jy8ID',
        event_callback: callback,
      });
      return false;
    };
  }, []);

  return null;
}
